import {
  type CreateQueryTypeRequest,
  type QueryTypeDetail,
  QueryTypeDetailSchema,
  type QueryTypeListQuery,
  type QueryTypeListResponse,
  QueryTypeListResponseSchema,
  type UpdateQueryTypeRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Query Type master API. Every response is validated with the shared Zod
 * schema so a server change can't sneak past the UI types.
 */

export const listQueryTypes = async (query: QueryTypeListQuery): Promise<QueryTypeListResponse> => {
  const { data } = await apiClient.get<unknown>('/query-types', { params: query });
  return QueryTypeListResponseSchema.parse(data);
};

export const getQueryType = async (id: string): Promise<QueryTypeDetail> => {
  const { data } = await apiClient.get<unknown>(`/query-types/${id}`);
  return QueryTypeDetailSchema.parse(data);
};

export const createQueryType = async (
  payload: CreateQueryTypeRequest,
): Promise<QueryTypeDetail> => {
  const { data } = await apiClient.post<unknown>('/query-types', payload);
  return QueryTypeDetailSchema.parse(data);
};

export const updateQueryType = async (
  id: string,
  payload: UpdateQueryTypeRequest,
): Promise<QueryTypeDetail> => {
  const { data } = await apiClient.patch<unknown>(`/query-types/${id}`, payload);
  return QueryTypeDetailSchema.parse(data);
};

export const deleteQueryType = async (id: string): Promise<void> => {
  await apiClient.delete(`/query-types/${id}`);
};

export const bulkDeleteQueryTypes = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/query-types/bulk-delete', { ids });
  return data;
};

export const bulkSetQueryTypesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/query-types/bulk-set-status', { ids, isActive });
  return data;
};
